import { normalizePhoneNumberToE164 } from '@apps/web/lib/phone_number_normalization';

export function inboxPersonConversationSearch({
    organizationId,
    mode,
    caregiverId,
    clientId,
}: {
    readonly organizationId: string;
    readonly mode?: 'live' | 'sandbox';
    readonly caregiverId?: string;
    readonly clientId?: string;
}): {
    readonly organizationId: string;
    readonly mode?: 'live' | 'sandbox';
    readonly caregiverId?: string;
    readonly clientId?: string;
} {
    // Opaque ids stay in the URL. Conversations loads the person and opens
    // their thread, or a draft when they have no history. A phone query
    // param would copy into history, referrer, and analytics.
    return {
        organizationId,
        mode,
        ...(caregiverId ? { caregiverId } : {}),
        ...(clientId ? { clientId } : {}),
    };
}

export function inboxConversationPhoneFilter(
    phone: string | null | undefined,
): string | undefined {
    return phone ? (normalizePhoneNumberToE164(phone) ?? undefined) : undefined;
}

export function inboxCaregiverPrimaryPhone(
    caregiver:
        | {
              readonly contacts?: ReadonlyArray<{
                  readonly type: string;
                  readonly address: string;
                  readonly is_primary?: boolean | null;
              }> | null;
          }
        | null
        | undefined,
): string | undefined {
    const contact =
        caregiver?.contacts?.find(
            (candidate) => candidate.type === 'phone' && candidate.is_primary,
        ) ??
        caregiver?.contacts?.find((candidate) => candidate.type === 'phone');
    return inboxConversationPhoneFilter(contact?.address);
}
